import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useChangePassword } from '@games/api';
import messages from 'intl/messages';
import { HelmetTitle } from '../helmet';
import { PasswordForm, PasswordValues } from './PasswordForm';

export const PasswordPage: React.FC = () => {
  const [{ loading, data }, changePassword] = useChangePassword();
  const { formatMessage } = useIntl();

  const submit = React.useCallback((variables: PasswordValues) => {
    changePassword({
      data: {
        oldPassword: variables.oldPassword,
        newPassword: variables.password,
      }
    });
  }, [changePassword]);

  return (
    <div className='container mx-auto'>
      <HelmetTitle message={formatMessage(messages.changePassword)} />
      <h2 className='text-center text-2xl mb-4 font-bold'>
        <FormattedMessage {...messages.changePassword} />
      </h2>
      <PasswordForm onSubmit={submit} loading={loading} />
      {data && data.success && (
        <div className='mt-3 alert alert-success' role='alert'>
          <FormattedMessage {...messages.passwordUpdated} />
        </div>
      )}
    </div>
  );
};
